/// <amd-module name="typeahead/core/plugins/CompositePageLoadHandler" />
/// <amd-dependency path="typeahead/core/context" name="coreContext"/>

/// <reference path="../../../typings/typeahead/IPageLoadHandler.d.ts" />

import {ClientHandlerRegistry} from "typeahead/client/ClientHandlerRegistry";
import {FlightSearchResultsPageHandler} from "typeahead/client/FlightSearchResultsPageHandler";
import {HotelSearchResultsPageHandler} from "typeahead/client/HotelSearchResultsPageHandler";
import {MercuryWizardHandler} from "typeahead/client/MercuryWizardHandler";
import {OpenSearchPageHandler} from "typeahead/client/OpenSearchPageHandler";
import * as abTest from "typeahead/core/abTest";
import {DefaultPluginAssembly} from "typeahead/core/plugins/DefaultPluginAssembly";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

export class CompositePageLoadHandler implements IPageLoadHandler {

    public static getInstance(): CompositePageLoadHandler {
        if (!CompositePageLoadHandler.instance) {
            CompositePageLoadHandler.instance = new CompositePageLoadHandler();
        }
        return CompositePageLoadHandler.instance;
    }

    private static instance: CompositePageLoadHandler;
    private static isPageLoadHandled: boolean = false;

    public handlePageLoad(pluginAssembly: IPluginAssembly): JQueryPromise<undefined> {
        let deferred: JQueryDeferred<undefined> = $.Deferred();
        if (!CompositePageLoadHandler.isPageLoadHandled) {
            abTest.evaluateAllExperiments(pluginAssembly);

            let options = {
                maxresults: 10,
            };

            let context: IContext = {
                clientId: TypeaheadUtils.getClientId(),
                expuserid: TypeaheadUtils.getExpUserId(),
                guid: TypeaheadUtils.getGuid(),
                lob: undefined, // lob is unknown during page load
                locale: coreContext.locale,
                serviceUrl: coreContext.serviceUrl,
                siteid: coreContext.siteid,
            };
            let pageLoadHandlers: IPageLoadHandler[] =
                pluginAssembly.get(DefaultPluginAssembly.pageLoadHandlerIdentifier);
            if (pageLoadHandlers && pageLoadHandlers.length > 0) {
                let handlePageLoadPromises: Array<JQueryPromise<undefined>> =
                    pageLoadHandlers.map((plugin: IPageLoadHandler) => {
                        return plugin.handlePageLoad(options, context);
                    });
                $.when.apply($, handlePageLoadPromises).done(() => {
                    deferred.resolve(undefined);
                });
            } else {
                deferred.resolve(undefined);
            }
            this.registerClients();
            CompositePageLoadHandler.isPageLoadHandled = true;
        } else {
            deferred.resolve(undefined);
        }
        return deferred.promise();
    }

    private registerClients() {
        ClientHandlerRegistry.registerClient(new MercuryWizardHandler());
        ClientHandlerRegistry.registerClient(new FlightSearchResultsPageHandler());
        ClientHandlerRegistry.registerClient(new HotelSearchResultsPageHandler());
        ClientHandlerRegistry.registerClient(new OpenSearchPageHandler());
        ClientHandlerRegistry.handlePageLoad();
    }
}
